import { render } from "./service-promise.vue?vue&type=template&id=4ca67fbf&scoped=true"
import script from "./service-promise.vue?vue&type=script&lang=js"
export * from "./service-promise.vue?vue&type=script&lang=js"

import "./service-promise.vue?vue&type=style&index=0&id=4ca67fbf&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca67fbf"]])

export default __exports__